if (!customElements.get('jupityr-home-journal')) customElements.define('jupityr-home-journal', class extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.home-journal__track');
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.querySelector('[data-prev]').onclick = () => this.advance(-1);
    this.querySelector('[data-next]').onclick = () => this.advance(1);
  }

  advance(direction) {
    const cards = [...this.track.children];
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const step = cards[0].getBoundingClientRect().width + gap;
    const max = this.track.scrollWidth - this.track.clientWidth;
    const next = direction > 0 && this.track.scrollLeft >= max - 3 ? 0 : direction < 0 && this.track.scrollLeft <= 3 ? max : this.track.scrollLeft + direction * step;
    this.track.scrollTo({left:next,behavior:this.reduced.matches ? 'instant' : 'smooth'});
  }
});
